import Actions from './display-unit-actions';
import Api from './display-unit-api';
import Collection from './display-unit-collection';
import Model from './display-unit-model';
import reducer from './display-unit-reducer';
import sagas from './display-unit-sagas';
import Selectors from './display-unit-selectors';

export default {
  Actions,
  Api,
  Collection,
  Model,
  name:       'displayUnit',
  namespace:  'displayUnit',
  pluralName: 'displayUnits',
  reducer,
  sagas:      [sagas],
  Selectors,
};
